import { Section } from '@/components/design-system/Section'
import { Badge } from '@/components/design-system/Badge'

interface Props {
  data: {
    byProvider: Record<string, number>
    byStatus: Record<string, number>
    expiredCount: number
    totalCount: number
  }
}

const providerLabels: Record<string, string> = {
  google: 'Google',
  meta: 'Meta',
  notion: 'Notion',
  slack: 'Slack',
  asana: 'Asana',
  trello: 'Trello',
  microvix: 'Microvix',
  composio: 'Composio',
}

const statusLabels: Record<string, string> = {
  active: 'Ativas',
  inactive: 'Inativas',
  expired: 'Expiradas',
  error: 'Erro',
}

export default function IntegrationHealthSection({ data }: Props) {
  return (
    <Section title="Saúde das Integrações">
      <div className="space-y-4">
        {data.totalCount === 0 ? (
          <p className="text-sm text-muted-foreground py-4 text-center">Nenhuma integração cadastrada.</p>
        ) : (
          <>
            {/* Expired token alert */}
            {data.expiredCount > 0 && (
              <div className="flex items-center gap-2 p-3 bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded-lg">
                <Badge tone="critical">{data.expiredCount} token{data.expiredCount > 1 ? 's' : ''} expirado{data.expiredCount > 1 ? 's' : ''}</Badge>
                <span className="text-sm text-red-700 dark:text-red-400">Integrações ativas com tokens vencidos</span>
              </div>
            )}

            {/* By provider */}
            <div>
              <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Por Provedor</p>
              <div className="grid grid-cols-2 gap-2">
                {Object.entries(data.byProvider)
                  .sort(([, a], [, b]) => b - a)
                  .map(([provider, count]) => (
                    <div key={provider} className="flex items-center justify-between py-1">
                      <span className="text-sm text-foreground">{providerLabels[provider] || provider}</span>
                      <span className="text-sm font-medium text-foreground">{count}</span>
                    </div>
                  ))}
              </div>
            </div>

            {/* By status */}
            <div>
              <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Por Status</p>
              <div className="flex flex-wrap gap-3">
                {Object.entries(data.byStatus).map(([status, count]) => (
                  <span key={status} className="text-sm text-foreground">
                    <span className="text-muted-foreground">{statusLabels[status] || status}:</span>{' '}
                    <span className="font-medium">{count}</span>
                  </span>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </Section>
  )
}
